import React from 'react'
import { Text, Box } from '@chakra-ui/react'
import { LabeledInput } from '@apex/component-library'
import { FormikErrors, FormikTouched } from 'formik'

export interface CheckMemosFormikValues {
  memo1?: string
  memo2?: string
  memo3?: string
}

export enum MemoLabels {
  memo1 = 'Memo 1 (appears on invoice)',
  memo2 = 'Memo 2 (appears on invoice)',
  memo3 = 'Memo 3 (appears on the check)'
}

interface CheckMemosFormProps {
  formikValues: CheckMemosFormikValues
  formikBlur: (e: React.FocusEvent<any>) => void
  formikTouched: FormikTouched<CheckMemosFormikValues>
  setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void
  errors: FormikErrors<CheckMemosFormikValues>
}

const CheckMemosForm = ({ formikValues, formikBlur, formikTouched, setFieldValue, errors }: CheckMemosFormProps) => {
  const { memo1, memo2, memo3 } = formikValues
  return (
    <>
      <Text as='h3' textStyle='h3'>
        Memos
      </Text>
      <Box height='5em'>
        <LabeledInput
          label={MemoLabels.memo1}
          charCounter={30}
          name='memo1'
          onBlur={formikBlur}
          value={memo1}
          onChange={(e) => {
            setFieldValue('memo1', e.target.value)
          }}
          errorMessage={errors?.memo1}
          isInvalid={formikTouched.memo1 && !!errors?.memo1}
        />
      </Box>
      <Box height='5em'>
        <LabeledInput
          label={MemoLabels.memo2}
          charCounter={30}
          name='memo2'
          onBlur={formikBlur}
          value={memo2}
          onChange={(e) => {
            setFieldValue('memo2', e.target.value)
          }}
          errorMessage={errors?.memo2}
          isInvalid={formikTouched.memo2 && !!errors?.memo2}
        />
      </Box>
      <Box height='5em'>
        <LabeledInput
          label={MemoLabels.memo3}
          charCounter={30}
          name='memo3'
          onBlur={formikBlur}
          value={memo3}
          onChange={(e) => {
            setFieldValue('memo3', e.target.value)
          }}
          errorMessage={errors?.memo3}
          isInvalid={formikTouched.memo3 && !!errors?.memo3}
        />
      </Box>
    </>
  )
}

export default CheckMemosForm
